import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { NewsEventModel } from '../../../domain/entities/NewsEventModel';
import TruncatedText from '../utilsComponents/TruncateTextComponents';
import FormattedDate from '../utilsComponents/FormattedDateComponents';

interface NewsEventItemProps {
    newsEvent: NewsEventModel
}

const NewsEventItemComponents: React.FC<NewsEventItemProps> = ({newsEvent}) => {
    const navigate = useNavigate();

    const handleClickDetail = () => {
        navigate("/detailnews", { state: { newsEvent }});
    };

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    // Handle window resize
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        // Add event listener
        window.addEventListener('resize', handleResize);

        // Cleanup
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Get current banners based on device type
    const pathImage = isMobile ? newsEvent.path_app : newsEvent.path;

    return(
        <div className="flex flex-col w-full h-64 md:h-96 bg-white cursor-pointer" onClick={handleClickDetail}>
            <img className="w-full h-48 md:h-64 rounded-lg md:rounded-3xl object-cover" src={pathImage} alt="News" />
            <FormattedDate 
                dateString={newsEvent.news_date_post} 
                className="text-sm text-gray-700 font-normal font-poppins mt-2" 
            />
            <TruncatedText 
                text={newsEvent.news_title} 
                maxLength={50} 
                className="text-base md:text-lg text-start text-gray-800 font-semibold font-poppins mt-1 md:mt-2" 
            />
        </div>
    );
}

export default NewsEventItemComponents;